import classNames from 'classnames'
import React from 'react'
import arrowLeft from '../../genericComponents/assets/arrow-left.svg'
import SVGIcon from '../../svg/SVGIcon'
import useToggle from '../../utils/useToggle'
import s from './FaqItem.less'
import HTMLTextFromMarkdown from '../../ui/HTMLTextFromMarkdown'

const FaqItem = ({ question, answer, clickDataTag, markdownContent }) => {
  const [open, onClick] = useToggle()

  return (
    <details
      className={classNames(s.details, clickDataTag && 'pub-click-event')}
      open={open}
      itemScope
      itemProp="mainEntity"
      itemType="https://schema.org/Question"
      data-tag={clickDataTag}
    >
      <summary className={s.summary} onClick={onClick}>
        <h3 itemProp="name">{question}</h3>
        <span className={s.chevron}>
          <SVGIcon url={arrowLeft} />
        </span>
      </summary>
      <div className={s.answer} itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
        <div itemProp="text">{markdownContent ? <HTMLTextFromMarkdown htmlText={answer} /> : answer}</div>
      </div>
    </details>
  )
}
export default FaqItem
